import { MdClose, MdPushPin } from "react-icons/md";

const SavedFiltersBar = ({
  presets,
  activePresetId,
  onApplyPreset,
  onDeletePreset,
  translate,
}) => {
  if (!presets || presets.length === 0) return null;

  return (
    <div className="advanced-filter__saved-bar">
      <span className="advanced-filter__saved-label">
        {translate.MY_FILTERS}
      </span>
      {presets.map((preset) => {
        const isActive = activePresetId === preset.id;
        return (
          <span
            key={preset.id}
            className={`advanced-filter__preset-tag ${
              isActive ? "advanced-filter__preset-tag--active" : ""
            }`}
            role="button"
            tabIndex={0}
            onClick={() => onApplyPreset(preset.id)}
            onKeyDown={(e) => {
              if (e.key === "Enter") onApplyPreset(preset.id);
            }}
          >
            <MdPushPin size={12} />
            {preset.name}
            <MdClose
              className="anticon-close"
              size={12}
              onClick={(e) => {
                e.stopPropagation();
                onDeletePreset(preset.id);
              }}
            />
          </span>
        );
      })}
    </div>
  );
};

export default SavedFiltersBar;
